import { render, staticRenderFns } from "./StaffTableToolbar.vue?vue&type=template&id=50aec45a&scoped=true&"
import script from "./StaffTableToolbar.vue?vue&type=script&lang=js&"
export * from "./StaffTableToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aec45a",
  null
  
)

export default component.exports